import propertiesNone from '@/layout/Editor/Properties/propertiesNone.vue';
<template>
  <div
    id="select-recipe-step-confirm-delete-modal"
    tabindex="-1"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-md max-h-full">
      <div class="relative bg-white rounded-lg shadow ">
        <button
          type="button"
          class="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center "
          data-modal-hide="select-recipe-step-confirm-delete-modal"
          @click="onConfirmClose"
        >
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
        <div class="p-4 md:p-5 text-center">
          <svg class="text-gray-400  w-11 h-11 mb-3.5 mx-auto" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
              clip-rule="evenodd"
            />
          </svg>

          <h3 class="mb-5 text-lg font-normal text-gray-500 ">Etes-vous sure de supprimer cette étape ?</h3>
        
           <button
            data-modal-hide="select-recipe-step-confirm-delete-modal"
            type="button"
            class="mr-3 py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100      "
            @click="onConfirmClose"
          >
            NON
          </button>


          <button
            data-modal-hide="select-recipe-step-confirm-delete-modal"
            type="button"
            class="text-white ml-3 bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
            @click="onConfirmDelete"
          >
            OUI
          </button>
        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 

export default {
  name: "ConfimDeleteModal",
  components: {},
  props: {
    input: {type: Object, default: null},
  },
emits: ["close","confirm"],
  data() {
    return {
      lg: "FR",
     
   
      transparent: false,
       
    };
  },
  watch: {
    
  },
  mounted() {
  
  },
  methods: {
    onConfirmDelete() {
    
  
      this.$emit("confirm", this.input);
 
    },

    onConfirmClose() {
      this.$emit("close");
      //  this.name = ""
    },
  },
};
</script>
